import $ from 'jquery';
document.addEventListener('DOMContentLoaded', function () {
  if (document.querySelector('.block-trailer-top')) {
    document.addEventListener('DOMContentLoaded', function () {
      const copyBtn = document.querySelector('.prime-share-copy');
      const tooltip = document.getElementById('copyTooltip');

      if (copyBtn) {
        copyBtn.addEventListener('click', () => {
          const url = copyBtn.getAttribute('data-url');
          navigator.clipboard.writeText(url).then(() => {
            tooltip.classList.add('active');
            setTimeout(() => tooltip.classList.remove('active'), 2000);
          });
        });
      }
    });

    const trailerSlideshow = $('.trailer-slideshow-items');
    const trailerSlideshowNavi = $('.slideshow-items-pagination');
    trailerSlideshow.slick({
      dots: false,
      infinite: true,
      fade: true,
      arrows: true,
      asNavFor: trailerSlideshowNavi,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            infinite: true,
          },
        },
      ],
    });

    trailerSlideshowNavi.slick({
      dots: false,
      infinite: true,
      arrows: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      centerMode: true,
      focusOnSelect: true,
      asNavFor: trailerSlideshow,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            infinite: true,
          },
        },
      ],
    });

    $('.slideshow-items-pagination .slick-slide').on('click', function () {
      var index = $(this).data('slick-index');
      trailerSlideshow.slick('slickGoTo', index);
    });
  }
});
